import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import "./styles/layerfilter.css";
import "./styles/logos.css";
import LanguageChange from "./language_change";
import { ReactComponent as MegamaLog } from "../logos/megama_logo.svg";
import IndexLayers from "./index_layers";
import SeconderyButtons from "./secondery_buttons";

const LayerFilter = ({ layers, flyOverData, setFlyOverData, map }) => {
  const [selectedButtonId, setSelectedButtonId] = useState(null);
  const [indexLabels, setIndexLabels] = useState([]);
  const [indexColors, setIndexColors] = useState([]);

  const [translation, i18n] = useTranslation("common");

  const headButtons = [
    { id: "bc", text: translation("primaryButtons.bc"), subButtons: [] },
    {
      id: "lc",
      text: translation("primaryButtons.lc"),
      subButtons: ["help", "info", "violation", "covidReport"],
    },
    { id: "nc", text: translation("primaryButtons.nc"), subButtons: [] },
  ];

  useEffect(() => {
    if (selectedButtonId) {
      handleChange(selectedButtonId);
      setFlyOverData({});
    }
  }, [selectedButtonId]);

  const handleChange = () => {
    const colors = [];
    const labels = [];
    layers.map((layer) => {
      map.setLayoutProperty(`${layer.id}-${layer.type}`, "visibility", "none");
      resetTransition(layer);

      if (layer.buttonsId.includes(selectedButtonId)) {
        map.setLayoutProperty(
          `${layer.id}-${layer.type}`,
          "visibility",
          "visible"
        );
        if (layer.indexColor) {
          colors.push(layer.indexColor);
          labels.push(layer.label);
        }
        handleTransition(layer);
      }
    });
    setIndexColors([...colors]);
    setIndexLabels([...labels]);
  };

  const resetTransition = (layer) => {
    if (layer.transition) {
      map.setPaintProperty(layer.transition.name, layer.transition.property, 0);
    }
  };

  const handleTransition = (layer) => {
    if (layer.transition) {
      setTimeout(() => {
        map.setPaintProperty(
          layer.transition.name,
          layer.transition.property,
          layer.transition.value
        );
      }, layer.transition.delay[selectedButtonId]);
    }
  };

  const checkButtonPress = (buttonId) => {
    if (selectedButtonId === buttonId) setSelectedButtonId("null");
    else setSelectedButtonId(buttonId);
  };

  return (
    <div className="full-page-container">
      <div className="top-page">
        <div className="side-page-container">
          <div>
            <div className="primary-b-container">
              {headButtons.map((button) => (
                <span className="primary-b-span">
                  <button
                    key={button.id}
                    className={
                      selectedButtonId === button.id ||
                      button.subButtons.includes(selectedButtonId)
                        ? "primary-button-active"
                        : "primary-button-deafult"
                    }
                    onClick={() => checkButtonPress(button.id)}
                  >
                    <span>{button.text}</span>
                  </button>
                  {button.subButtons.length !== 0 ? (
                    <SeconderyButtons
                      checkButtonPress={checkButtonPress}
                      selectedButtonId={selectedButtonId}
                      flyOverData={flyOverData}
                    />
                  ) : null}
                </span>
              ))}
            </div>
          </div>
          <IndexLayers
            colors={indexColors}
            labels={indexLabels}
            translation={translation}
          />
        </div>
        <LanguageChange i18n={i18n} />
      </div>

      <div className="megama-div">
        <MegamaLog className="megama-logo" />
      </div>
    </div>
  );
};

export default LayerFilter;
